/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { hookMethodDangerously } from '@slardar/sdk-template';
import { getDefaultFetch, getDefaultBrowser, getDefaultPerformance, reportSelfError } from '../../utils';
import { checkIsIgnored, getGetLatestEntryByName } from '../ajax/util';
import { getFetchUrl, getRequestParams, mergeHeaders, getFetchBody, isHttpURL } from './util';
var hookFetch = function (_fetch, props, cb, Headers, Request, getLatestEntryByName) {
    return function (req, options) {
        if (options === void 0) { options = {}; }
        var fetchPromise = _fetch(req, options);
        var url = getFetchUrl(req, false, Request);
        // 有业务方通过 fetch 来将 base64 转化成 blob || 业务方自行配置ignore
        if (!isHttpURL(url) || checkIsIgnored(props.ignoreUrls, url)) {
            return fetchPromise;
        }
        var hookedCb = props.hookCbAtReq(cb);
        var httpPayload = {
            api: 'fetch',
            request: getRequestParams(req instanceof Request ? req.url : req, req, options, Request),
            response: {
                is_custom_error: false,
            },
            duration: 0,
        };
        try {
            httpPayload.request.headers = mergeHeaders(Headers, req.headers, options.headers);
        }
        catch (e) {
            reportSelfError(e);
        }
        var revokeCb = function () {
            hookedCb &&
                hookedCb({
                    ev_type: 'http',
                    payload: httpPayload,
                });
        };
        var onResolve = function (res) {
            var _a;
            try {
                httpPayload.response.status = res.status || 0;
                httpPayload.response.headers = mergeHeaders(Headers, res.headers);
                httpPayload.duration = Date.now() - httpPayload.request.timestamp;
                var collectBodyOnError = props.collectBodyOnError, extraExtractor_1 = props.extraExtractor;
                try {
                    extraExtractor_1 &&
                        res
                            .clone()
                            .json()
                            .then(function (o) {
                            var extra = extraExtractor_1(o, httpPayload);
                            if (extra) {
                                httpPayload.extra = extra;
                                httpPayload.response.is_custom_error = true;
                            }
                        });
                }
                catch (_o) {
                    // do nothing
                }
                if (collectBodyOnError && res.status >= 400) {
                    // fetch response body 正确地拿到涉及到异步和拷贝 先不拿
                    httpPayload.request.body = (_a = getFetchBody(req, options, Request)) === null || _a === void 0 ? void 0 : _a.toString();
                }
                var setTiming_1 = function () { return (httpPayload.response.timing = getLatestEntryByName(res.url)); };
                // 存在 entry 立即拿拿不到的情况
                setTimeout(function () {
                    setTiming_1();
                    revokeCb();
                }, 100);
            }
            catch (e) {
                reportSelfError(e);
            }
        };
        var onReject = function () {
            var _a;
            try {
                // 请求失败,或被拦截
                httpPayload.response.status = 0;
                httpPayload.duration = Date.now() - httpPayload.request.timestamp;
                // there won't be response in reject handler unless aborted
                // https://fetch.spec.whatwg.org/#:~:text=If%20response%E2%80%99s%20body%20is%20not%20null%20and%20is%20readable
                if (props.collectBodyOnError) {
                    /* istanbul ignore next */
                    httpPayload.request.body = (_a = getFetchBody(req, options, Request)) === null || _a === void 0 ? void 0 : _a.toString();
                }
            }
            catch (e) {
                reportSelfError(e);
            }
            revokeCb();
        };
        fetchPromise.then(onResolve, onReject);
        return fetchPromise;
    };
};
export var FetchMonitor = function (global, Headers, Request, performance) {
    if (global === void 0) { global = getDefaultFetch() && getDefaultBrowser(); }
    if (Headers === void 0) { Headers = window.Headers; }
    if (Request === void 0) { Request = window.Request; }
    if (performance === void 0) { performance = getDefaultPerformance(); }
    if (!global || !Headers || !Request) {
        return;
    }
    var getLatestEntryByName = getGetLatestEntryByName(performance);
    return function (props, cb) {
        if (props.autoWrap) {
            // 劫持用户 fetch 方法
            hookMethodDangerously(global, 'fetch', hookFetch)(props, cb, Headers, Request, getLatestEntryByName);
        }
        var wrapFetch = function (fetch, p, c) {
            if (p === void 0) { p = props; }
            if (c === void 0) { c = cb; }
            return hookFetch(fetch, p, c, Headers, Request, getLatestEntryByName);
        };
        return [wrapFetch];
    };
};
//# sourceMappingURL=index.js.map